import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const fetchUserGroupDetails = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useUserGroupDetails = (
    props: any
): UseQueryResult<AxiosResponse<any, any>, unknown> => {
    const { getToken } = useAuth();
    const { id } = props;

    const url = `/metadata/usergroup/${id}`;
    return useQuery(`user-group-details-${id}`, async () =>
        fetchUserGroupDetails(url, getToken())
    );
};
